
import http from './http'
let url = 'Pagamento/'
// import axios from 'axios'
// require('@/service/service_pagamento/httpsemtoken')
// const urlPagamento = sessionStorage.getItem('APIPagamentos')
// console.log('urlPagamento', urlPagamento)
// var http = axios.create({
//     baseURL:urlPagamento
// })
// http.defaults.headers.modulo = 4
export function postAutorizacao(payload, obj) {
    var headers = []
    headers[0] = { nome: 'id', valor: obj.MerchantId}
    headers[1] = { nome: 'key', valor: obj.MerchantKey}
    const vrCrd = 1
    headers[2] = { nome: 'crd', valor: vrCrd}
    headers[3] = { nome: 'amb', valor: obj.Ambiente}
    http.addHeaderPost(headers)
    return http.post(url + 'Credito/autorizacao', payload)
}
export function postCaptura(payload) {
    return http.post(url + 'Credito/captura', payload)
}
export function postCancelamento(payload) {
    return http.post(url + 'Credito/cancelamento', payload)
}